import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { Row, Col } from 'antd';
import { find, map, path, pathEq } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { ACTION_VACANCY_SIDEBAR } from 'constants/sidebarTypes';
import DropdownStatusFilter from 'components/common/controls/DropdownStatusFilter';
import RefreshButton from 'components/common/controls/RefreshButton';
import StaticTable from 'components/common/tableComponents/StaticTable';
import { RadioboxCell, SidebarLink } from 'components/common/tableComponents/cellTemplates';

import { fullAutoOptions } from 'constants/asyncClient';
import { getActionVacancyList } from 'actions/asyncActions';
import { ApplicationButton } from 'components/cards/education/application/ApplicationButton';

const getVacancyName = path(['vacancy', 0, 'text']);

@withAsyncActions({
    getActionVacancyList: getActionVacancyList
        .withPayload(props => map(Boolean, props.filters))
}, fullAutoOptions)
export default class ActionVacancyListTable extends Component {
    static propTypes = {
        getActionVacancyList: PropTypes.object.isRequired,
        filters: PropTypes.object.isRequired,
        defaultFilters: PropTypes.object.isRequired,
        onFiltersChange: PropTypes.func.isRequired,
        onSelect: PropTypes.func.isRequired,
        selected: PropTypes.number,
    }

    tableColumns = [
        {
            name: 'checkbox',
            width: 50,
            template: ({ item }) => (
                <RadioboxCell
                    setSelected={this.props.onSelect}
                    selected={this.props.selected}
                    rowIndex={path(['vacancy', 0, 'id'], item)}
                />
            ),
        },
        {
            name: 'number',
            width: 35,
            template: ({ rowIndex }) => rowIndex + 1,
        },
        {
            name: 'vacancy',
            label: <Translate content="education.action.headers.project" />,
            template: ({ item }) => (
                <SidebarLink
                    componentName={ACTION_VACANCY_SIDEBAR}
                    item={path(['vacancy', 0], item)}
                    value={getVacancyName(item)}
                />
            ),
        },
        {
            name: 'responsible',
            width: 200,
            label: <Translate content="education.actionVacancy.headers.responsible" />,
            template: path(['item', 'responsible', 0, 'text']),
        },
        {
            name: 'type',
            width: 290,
            label: <Translate content="education.actionVacancy.headers.type" />,
            template: ({ value }) => value && (
                <Translate content={`education.actionVacancy.state.${value}`} fallback=" " />
            ),
        }
    ];

    render() {
        const { selected, filters, defaultFilters, onFiltersChange } = this.props;
        const { data, meta, refresh } = this.props.getActionVacancyList;
        const actionVacancy = selected && find(
            pathEq(['vacancy', 0, 'id'], selected),
            data.vacancies
        );

        return (
            <div>
                <Row className="react-table-controls">
                    <Col span={8}>
                        <ApplicationButton id={selected} name={getVacancyName(actionVacancy)} />
                    </Col>
                    <Col span={16} className="text-right icon-bar">
                        <DropdownStatusFilter
                            filters={filters}
                            defaultFilters={defaultFilters}
                            translation='filterStatus.actionVacancy.'
                            onFiltersChange={onFiltersChange}
                        />
                        <RefreshButton refreshMeta={meta} handleRefresh={refresh} />
                    </Col>
                </Row>
                <div>
                    <StaticTable
                        meta={meta}
                        refresh={refresh}
                        className="width-auto-table"
                        columns={this.tableColumns}
                        items={data.vacancies}
                    />
                </div>
            </div>
        );
    }
}
